(() => {
  'use strict';
  const parse = (el, fallback = {}) => { try { return JSON.parse(el?.textContent || '{}'); } catch { return fallback; } };
  const config = parse(document.getElementById('CarraConfig'));
  const labels = config.labels || {};
  const currency = config.currency || 'USD';
  const money = cents => {
    try { return new Intl.NumberFormat(config.locale || 'en', {style: 'currency', currency}).format(Number(cents || 0) / 100); }
    catch { return `${currency} ${(Number(cents || 0) / 100).toFixed(2)}`; }
  };
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const icon = name => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('class', 'icon');
    svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.5'); svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS(svg.namespaceURI, 'path');
    path.setAttribute('d', name === 'plus' ? 'M5 12h14M12 5v14' : name === 'bag' ? 'M5 7h14l1 14H4L5 7ZM8 8V6a4 4 0 018 0v2' : 'M5 12h14');
    svg.append(path); return svg;
  };
  const syncDialogLock = () => document.body.classList.toggle('dialog-open', !!document.querySelector('dialog[open]'));
  const openDialog = dialog => { if (dialog && !dialog.open) { dialog.showModal(); syncDialogLock(); } };
  const closeDialog = dialog => { dialog?.close(); syncDialogLock(); };
  const initDialog = dialog => {
    if (dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    dialog.addEventListener('close', syncDialogLock);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(dialog);
    });
  };
  const request = async (url, payload) => {
    const response = await fetch(url, {method: payload ? 'POST' : 'GET', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, ...(payload ? {body: JSON.stringify(payload)} : {cache: 'no-store'})});
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : labels.cartError);
    return data;
  };
  let cartBusy = false;
  let cartRequest = 0;
  const drawer = () => document.getElementById('CarraCart');
  const cartError = message => {
    const target = drawer()?.querySelector('[data-cart-error]');
    if (target) {target.textContent = message || ''; target.hidden = !message;}
  };
  const setCartBusy = busy => {
    cartBusy = busy;
    drawer()?.querySelectorAll('[data-cart-change], button[name="checkout"]').forEach(button => button.disabled = busy);
    drawer()?.setAttribute('aria-busy', String(busy));
  };
  function renderCart(cart) {
    const d = drawer();
    document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = cart.item_count);
    if (!d) return;
    const itemsNode = d.querySelector('[data-cart-items]');
    itemsNode.replaceChildren();
    if (!cart.items?.length) {
      const empty = el('div', 'cart-empty');
      empty.append(icon('bag'), el('h3', '', labels.empty), el('p', '', labels.emptySub));
      itemsNode.append(empty);
    } else {
      cart.items.forEach(item => {
        const row = el('article', 'cart-item'); row.dataset.lineKey = item.key;
        const imageLink = el('a', 'cart-item__image'); imageLink.href = item.url;
        const isBlanket = item.handle === config.productHandle || item.url?.split('?')[0].endsWith('/products/' + config.productHandle);
        const imageSource = item.featured_image?.url || item.image || (isBlanket ? config.productImage : null);
        if (imageSource) {
          const image = el('img'); image.src = imageSource; image.width = 180; image.height = 210;
          image.alt = item.featured_image?.alt || item.product_title; image.loading = 'lazy'; imageLink.append(image);
        }
        const details = el('div', 'cart-item__details');
        const title = el('a', 'cart-item__title', item.product_title); title.href = item.url;
        details.append(title);
        if (item.variant_title && item.variant_title !== 'Default Title') details.append(el('p', 'cart-item__variant', item.variant_title));
        Object.entries(item.properties || {}).forEach(([key, value]) => {
          if (!key.startsWith('_') && value) details.append(el('p', 'cart-item__variant', `${key}: ${value}`));
        });
        const prices = el('div', 'cart-item__prices');
        if (item.original_line_price > item.final_line_price) prices.append(el('s', '', money(item.original_line_price)));
        prices.append(el('span', '', money(item.final_line_price)));
        details.append(prices);
        (item.line_level_discount_allocations || []).forEach(discount => details.append(el('p', 'cart-discount', discount.discount_application.title)));
        const controls = el('div', 'cart-item__controls');
        const quantity = el('div', 'quantity-control');
        const button = (kind, value, label) => {
          const b = el('button'); b.type = 'button'; b.dataset.cartChange = item.key; b.dataset.quantity = value;
          b.setAttribute('aria-label', `${label}: ${item.product_title}`); b.append(icon(kind)); return b;
        };
        quantity.append(button('minus', Math.max(0, item.quantity - 1), labels.decrease), el('span', '', String(item.quantity)), button('plus', item.quantity + 1, labels.increase));
        const remove = el('button', 'cart-item__remove', labels.remove); remove.type = 'button'; remove.dataset.cartChange = item.key; remove.dataset.quantity = 0;
        remove.setAttribute('aria-label', `${labels.remove}: ${item.product_title}`);
        controls.append(quantity, remove); details.append(controls); row.append(imageLink, details); itemsNode.append(row);
      });
    }
    d.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price);
    d.querySelector('[data-cart-footer]').hidden = !cart.items?.length;
    const discounts = d.querySelector('[data-cart-discounts]'); discounts.replaceChildren();
    (cart.cart_level_discount_applications || []).forEach(item => discounts.append(el('p', 'cart-discount', `${item.title}: −${money(item.total_allocated_amount)}`)));
  }
  async function refreshCart() {
    const token = ++cartRequest;
    const d = drawer(); if (!d) return;
    cartError(''); d.setAttribute('aria-busy', 'true');
    d.querySelector('[data-cart-footer]').hidden = true;
    d.querySelector('[data-cart-items]').replaceChildren(el('p', '', labels.loading));
    try {
      const cart = await request(config.routes.cart);
      if (token === cartRequest) renderCart(cart);
    } catch (error) {
      if (token !== cartRequest) return;
      cartError(error.message || labels.cartError);
      const retry = el('button', 'cart-refresh', labels.refresh); retry.type = 'button'; retry.dataset.cartRefresh = 'true';
      d.querySelector('[data-cart-items]').replaceChildren(retry);
    } finally { if (token === cartRequest) d.setAttribute('aria-busy', 'false'); }
  }
  const openCart = async () => { openDialog(drawer()); await refreshCart(); };
  async function changeCart(button) {
    if (cartBusy) return;
    setCartBusy(true); cartError(''); ++cartRequest;
    const key = button.dataset.cartChange;
    try {
      const cart = await request(config.routes.change, {id: key, quantity: Number(button.dataset.quantity)});
      renderCart(cart);
      const replacement = [...drawer().querySelectorAll('[data-cart-change]')].find(node => node.dataset.cartChange === key);
      (replacement || drawer().querySelector('[data-cart-close]'))?.focus({preventScroll: true});
    } catch (error) { cartError(error.message || labels.cartError); }
    finally {setCartBusy(false);}
  }
  function initGallery(root) {
    const gallery = root.querySelector('[data-gallery]'); if (!gallery || gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = [...track.querySelectorAll('[data-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-thumb]')];
    let active = 0, frame;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const update = () => {
      active = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
      gallery.querySelector('[data-gallery-counter]').textContent = `${String(active + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === active)));
    };
    const go = index => {const target = (index + slides.length) % slides.length; track.scrollTo({left: target * track.clientWidth, behavior: reduced ? 'instant' : 'smooth'});};
    root.carraGalleryGo = mediaId => { const idx = slides.findIndex(slide => slide.dataset.mediaId === String(mediaId)); if (idx >= 0) go(idx); };
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => go(active - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => go(active + 1));
    thumbs.forEach(thumb => thumb.addEventListener('click', () => go(Number(thumb.dataset.thumb))));
    track.addEventListener('scroll', () => {cancelAnimationFrame(frame); frame = requestAnimationFrame(update);}, {passive: true});
    track.addEventListener('keydown', event => {if (['ArrowLeft', 'ArrowRight'].includes(event.key)) {event.preventDefault(); go(active + (event.key === 'ArrowRight' ? 1 : -1));}});
    track.querySelectorAll('[data-zoom]').forEach(button => button.addEventListener('click', () => {
      const dialog = root.querySelector('[data-image-dialog]');
      const source = button.querySelector('img'); if (!source) return;
      const image = source.cloneNode(); image.loading = 'eager'; image.sizes = '90vw';
      dialog.querySelector('[data-zoom-image]').replaceChildren(image); openDialog(dialog);
    }));
  }
  function initProduct(root) {
    initGallery(root);
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = parse(root.querySelector('[data-product-json]'));
    if (!data.variants) return;
    const selects = [...root.querySelectorAll('[data-variant-select]')];
    const radios = [...root.querySelectorAll('.bundle-options input')];
    const add = root.querySelector('[data-add]');
    const errorNode = root.querySelector('[data-product-error]');
    let busy = false;
    const variantAt = index => data.variants.find(v => String(v.id) === selects[index]?.value);
    const qty = () => Number(radios.find(radio => radio.checked)?.value || 1);
    const update = () => {
      const one = variantAt(0), two = variantAt(1);
      const multiplier = Number(root.dataset.duoMultiplier || 100) / 100;
      const pair = (one?.price || 0) + (two?.price || 0);
      const pairPrice = Math.round(pair * multiplier);
      const set = (selector, value) => root.querySelectorAll(selector).forEach(node => node.textContent = value);
      set('[data-unit-price], [data-solo-price]', money(one?.price));
      set('[data-duo-price]', money(pairPrice)); set('[data-duo-compare]', money(pair));
      const compare = root.querySelector('[data-unit-compare]');
      compare.hidden = !(one?.compare > one?.price); compare.textContent = money(one?.compare);
      const total = qty() === 2 ? pairPrice : one?.price;
      set('[data-total], [data-sticky-price]', money(total));
      root.querySelector('[data-variant-row="2"]').hidden = qty() !== 2;
      root.querySelector('[data-duo-help]').hidden = qty() !== 2;
      const available = !!one?.available && (qty() !== 2 || !!two?.available);
      add.disabled = busy || !available;
      root.querySelector('[data-add-label]').textContent = busy ? labels.adding : available ? labels.add : labels.soldOut;
      const sticky = root.querySelector('[data-sticky-add]'); if (sticky) sticky.disabled = busy || !available;
    };
    root.carraUpdate = update;
    root.carraVariants = data.variants;
    radios.forEach(radio => radio.addEventListener('change', update));
    selects.forEach((select, i) => select.addEventListener('change', () => {
      update(); errorNode.hidden = true;
      if (i === 0) {
        const variant = variantAt(0);
        if (variant?.media) root.carraGalleryGo?.(variant.media);
        if (location.pathname.includes('/products/')) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
      }
    }));
    add.addEventListener('click', async () => {
      if (busy) return;
      const selected = qty() === 2 ? [variantAt(0), variantAt(1)] : [variantAt(0)];
      errorNode.hidden = true;
      if (selected.some(variant => !variant?.available)) {errorNode.textContent = labels.choose; errorNode.hidden = false; return;}
      busy = true; update(); add.setAttribute('aria-busy', 'true');
      const grouped = new Map();
      selected.forEach(variant => grouped.set(variant.id, (grouped.get(variant.id) || 0) + 1));
      const items = [...grouped].map(([id, quantity]) => ({id, quantity}));
      try {await request(config.routes.add, {items}); await openCart();}
      catch (error) {errorNode.textContent = error.message || labels.error; errorNode.hidden = false;}
      finally {busy = false; add.removeAttribute('aria-busy'); update();}
    });
    root.querySelector('[data-sticky-add]')?.addEventListener('click', () => add.click());
    const sticky = root.querySelector('[data-sticky-buy]');
    if (sticky && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {const entry = entries[0]; sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;});
      observer.observe(add); root.carraObserver = observer;
    }
    update();
  }
  const init = (scope = document) => {
    scope.querySelectorAll('dialog').forEach(initDialog);
    scope.querySelectorAll('[data-product-section]').forEach(initProduct);
  };
  document.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const cartOpen = target.closest('[data-cart-open]');
    if (cartOpen) {event.preventDefault(); openCart(); return;}
    if (target.closest('[data-cart-close]')) {closeDialog(drawer()); return;}
    if (target.closest('[data-cart-refresh]')) {refreshCart(); return;}
    const change = target.closest('[data-cart-change]'); if (change) {changeCart(change); return;}
    const dialogClose = target.closest('[data-dialog-close]'); if (dialogClose) {closeDialog(dialogClose.closest('dialog')); return;}
    const duo = target.closest('[data-pick-duo]');
    if (duo) {
      const root = document.querySelector('[data-product-section]');
      const radio = root?.querySelector('.bundle-options input[value="2"]');
      if (radio) {radio.checked = true; radio.dispatchEvent(new Event('change', {bubbles:true}));}
    }
    const anchor = target.closest('a[href*="#"]');
    if (anchor) {
      let url; try {url = new URL(anchor.href);} catch {return;}
      if (url.origin === location.origin && url.pathname === location.pathname && url.hash) {
        const destination = document.getElementById(decodeURIComponent(url.hash.slice(1)));
        if (destination?.tagName === 'DETAILS') destination.open = true;
        target.closest('.mobile-nav')?.removeAttribute('open');
      }
    }
  });
  document.addEventListener('change', event => {if (event.target.matches('[data-sort]')) event.target.form.requestSubmit();});
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-product-section]').forEach(root => root.carraObserver?.disconnect()));
  window.addEventListener('pageshow', event => {if (event.persisted && config.routes) request(config.routes.cart).then(renderCart).catch(() => {});});
  init();
  if (location.hash) {
    const match = document.getElementById(location.hash.slice(1));
    const details = match?.closest('details'); if (details) details.open = true;
  }
})();
